import { ElementType, JSX } from 'react';

export interface PartialPropsStep {
    slug: string;
    title: string;
    path: string;
    element: ElementType | JSX.Element;
    source?: ('site' | 'concessionnaire' | 'courtier' | 'conseiller')[];
    isAvenant?: boolean;
    isAffaireNouvelle?: boolean;
    avenantMotifs?: string[];
    avenantInterlocuteurs?: string[];
    showWhen?: (state: any, initialState: any) => boolean;
}

export interface StepProps extends PartialPropsStep {
    index: number;
}

export const addIndexToSteps = (steps: PartialPropsStep[]) => {
    return steps.map((step, index) => {
        return {
            ...step,
            index,
        };
    });
};

export const getStepBySlug = (slug: string, steps: StepProps[]) => {
    try {
        const step = steps.find((step) => step.slug === slug);
        if (!step) {
            throw new Error(`Step with slug ${slug} not found`);
        }
        return step;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
        throw new Error(`Step with slug ${slug} not found`);
    }
};

